import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getVisas } from "../../services/salaryService";
import {
  generateSalaryReport,
  generateSalary,
} from "../../services/reportService";

import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table, Button, Message, Confirm } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import auth from "../../services/authService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "../common/select";
import ReactToPrint from "react-to-print";
import SalaryPrintReport from "./print/salary";

class SalaryReport extends Component {
  state = {
    startDate: new Date(),
    endDate: new Date(),
    visas: [],
    showSalaryForm: false,
    showError: false,
    showErrorGenerateSalry: false,
    salaries: [],
    open: false,
    openSingle: false,
    totalSalaryAmount: 0,
    reportDateStart: "",
    reportDateEnd: "",
    salaryMonth: "",
  };

  handleChangeStartDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    const { data: visasAccounts } = await getVisas();
    const visas = [{ id: "", name: "Select Visa Account" }, ...visasAccounts];

    this.setState({ blocking: false, visas });
  }

  show = () => this.setState({ open: true });
  showSingle = () => this.setState({ openSingle: true });

  handleConfirm = async () => {
    this.setState({ open: false, blocking: true });

    var event = new Date(this.state.startDate);
    let startDate = JSON.stringify(event);
    startDate = startDate.slice(1, 11);

    event = new Date(this.state.endDate);
    let endDate = JSON.stringify(event);
    endDate = endDate.slice(1, 11);

    const visaID = document.getElementById("visa_id").value;

    // if (visaID == "") {
    //   toast.warn("Please select employee to generate salary");
    //   this.setState({ blocking: false });
    //   return false;
    // }

    const verifyData = {
      startDate: startDate,
      endDate: endDate,
      visaID: visaID == "" ? "all" : visaID,
    };

    this.setState({ showError: false, showErrorGenerateSalry: false });

    const res = await generateSalary(verifyData);
    if (res.data.proceed === "no") {
      this.setState({
        showErrorGenerateSalry: true,
        blocking: false,
        showSalaryForm: false,
      });
    } else {
      this.setState({ blocking: false, showSalaryForm: false });
      toast.success("Salaries has been generated successfully.");
    }
  };
  handleCancel = () => this.setState({ open: false });
  handleCancelSingle = () => this.setState({ openSingle: false });

  doSubmit = async () => {
    try {
      var event = new Date(this.state.startDate);
      let startDate = JSON.stringify(event);
      startDate = startDate.slice(1, 11);
      this.setState({
        reportDateStart:
          event.getDate() +
          "-" +
          (event.getMonth() + 1) +
          "-" +
          event.getFullYear(),
      });

      event = new Date(this.state.endDate);
      let endDate = JSON.stringify(event);
      endDate = endDate.slice(1, 11);
      this.setState({
        reportDateEnd:
          event.getDate() +
          "-" +
          (event.getMonth() + 1) +
          "-" +
          event.getFullYear(),
      });

      const visaID = document.getElementById("visa_id").value;

      this.setState({
        showError: false,
        showErrorGenerateSalry: false,
        blocking: true,
      });

      const verifyData = {
        startDate: startDate,
        endDate: endDate,
        visaID: visaID != null ? visaID : "all",
      };

      const res = await generateSalaryReport(verifyData);

      if (res.data.proceed === "no") {
        this.setState({
          showError: true,
          showSalaryForm: false,
          blocking: false,
        });
      } else {
        //alert(startDate+"=="+endDate);
        this.setState({
          showError: false,
          showSalaryForm: true,
          salaryMonth: res.data.salaryMonth,
          blocking: false,
          salaries: res.data.reportData,
          totalSalaryAmount: res.data.totalSalaryAmount,
          showErrorGenerateSalry: false,
        });
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    if (auth.getCurrentUser().role != "salary-admin") {
      return "Your are authorized to perform this action.";
    }
    const { salaries, totalSalaryAmount } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Salary Report</h1>

        <div className="grid salary-report-filters">
          <DatePicker
            selected={this.state.startDate}
            onChange={this.handleChangeStartDate}
            placeholderText="Select Start Date"
            className="input"
          />
          <div></div>
          <DatePicker
            selected={this.state.endDate}
            onChange={this.handleChangeEndDate}
            className="input"
            placeholderText="Select End Date"
          />
          <div></div>
          <select
            name="visa_id"
            id="visa_id"
            selected={this.state.visa_id}
            className="input"
            onChange={this.handleChangeVisaId}
          >
            {this.state.visas.map((option) => (
              <option key={option.id} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
          <div></div>
          <button className="btn btn--primary" onClick={this.doSubmit}>
            Submit
          </button>
        </div>

        <center>
          <div className="ui error form" style={{ width: "40%" }}>
            <Message
              negative
              style={{
                display: this.state.showError == true ? "block" : "none",
              }}
            >
              <Message.Header>Error</Message.Header>
              <p>Salary data not found for the dates specified.</p>
            </Message>
            <Message
              negative
              style={{
                display:
                  this.state.showErrorGenerateSalry == true ? "block" : "none",
              }}
            >
              <Message.Header>Error</Message.Header>
              <p>Salary already generted for the date specified.</p>
            </Message>
          </div>

          <div
            className="scrap-report"
            style={{
              display: this.state.showSalaryForm == true ? "block" : "none",
            }}
          >
            <button className="btn btn--accent" onClick={this.show}>
              Generate Salary
            </button>
            <Confirm
              open={this.state.open}
              header="Generate Salary"
              content={
                document.getElementById("visa_id") == null ||
                document.getElementById("visa_id").value == ""
                  ? "Are you sure, you want to generate salary for all employees?"
                  : "Are you sure, you want to generate salary?"
              }
              onCancel={this.handleCancel}
              onConfirm={this.handleConfirm}
            />
            <div className="scrap-report__print">
              <ReactToPrint
                trigger={() => <a href="#">Print this out!</a>}
                content={() => this.componentRef}
              />
            </div>

            <SalaryPrintReport
              reportDateStart={this.state.reportDateStart}
              reportDateEnd={this.state.reportDateEnd}
              salaries={salaries}
              salaryMonth={this.state.salaryMonth}
              totalSalaryAmount={totalSalaryAmount}
              ref={(el) => (this.componentRef = el)}
            />
          </div>
        </center>
      </BlockUi>
    );
  }
}

export default SalaryReport;
